import type { ImageCardData } from "../types";

export function ImageCard({ data }: { data: ImageCardData }) {
	if (data.textPosition === "overlay") {
		return (
			<div className="group border-ivory/5 bg-dark-accent hover:border-gold/30 relative overflow-hidden border transition-all duration-500">
				<div className="relative aspect-[4/5] overflow-hidden">
					<img
						alt={data.imageAlt}
						className="h-full w-full object-cover opacity-60 grayscale transition-all duration-1000 group-hover:opacity-100 group-hover:grayscale-0"
						src={data.imageSrc}
					/>
					<div className="from-dark-accent absolute inset-0 bg-gradient-to-t via-transparent to-transparent" />
					<div className="absolute right-8 bottom-8 left-8">
						<span className="text-gold mb-3 block text-[10px] font-medium tracking-widest uppercase">
							{data.category}
						</span>
						<h2 className="font-display mb-4 text-3xl leading-tight">
							{data.title}
						</h2>
						<p className="text-ivory/60 max-w-xs text-sm leading-relaxed font-light">
							{data.description}
						</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="group border-ivory/5 bg-dark-accent hover:border-gold/30 relative overflow-hidden border transition-all duration-500">
			<div className="relative aspect-video overflow-hidden">
				<img
					alt={data.imageAlt}
					className="h-full w-full object-cover opacity-50 transition-opacity duration-700 group-hover:opacity-80"
					src={data.imageSrc}
				/>
			</div>
			<div className="p-8">
				<span className="text-gold mb-3 block text-[10px] font-medium tracking-widest uppercase">
					{data.category}
				</span>
				<h2 className="font-display mb-4 text-2xl leading-tight">
					{data.title}
				</h2>
				<p className="text-ivory/60 text-sm leading-relaxed font-light">
					{data.description}
				</p>
			</div>
		</div>
	);
}
